import type { ReactNode } from 'react'

import { CelebrationIllustration, EmptyBoxIllustration } from '@/components/illustrations'
import { cn } from '@/lib/cn'

const illustrations = {
  box: EmptyBoxIllustration,
  celebration: CelebrationIllustration,
} as const

/**
 * Keadaan kosong selalu menjelaskan langkah berikutnya, bukan sekadar
 * memberi tahu bahwa tidak ada data. Layar kosong tanpa arahan adalah tempat
 * pengguna berhenti.
 */
export function EmptyState({
  icon,
  illustration,
  title,
  description,
  action,
  className,
}: {
  icon?: ReactNode
  /** Gambar besar sebagai ganti ikon kecil, untuk layar yang benar-benar kosong. */
  illustration?: keyof typeof illustrations
  title: string
  description?: string
  action?: ReactNode
  className?: string
}) {
  const Illustration = illustration ? illustrations[illustration] : null

  return (
    <div className={cn('flex flex-col items-center justify-center px-6 py-14 text-center', className)}>
      {Illustration ? (
        <div className="float-slow mb-5">
          <Illustration />
        </div>
      ) : null}
      {!Illustration && icon ? (
        <div className="mb-4 flex size-14 items-center justify-center rounded-2xl bg-brand-soft text-brand">
          {icon}
        </div>
      ) : null}
      <h3 className="text-base font-bold text-ink">{title}</h3>
      {description ? <p className="mt-1.5 max-w-md text-sm text-muted">{description}</p> : null}
      {action ? <div className="mt-5">{action}</div> : null}
    </div>
  )
}
